import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./main/App";
import reportWebVitals from "./reportWebVitals";
import { PostHogErrorBoundary, PostHogProvider } from "posthog-js/react";
import AppCrashFallback from "./utils/AppCrashFallback";
import { maskQuickLinkToken } from "./utils/posthog/maskQuickLinkToken";
import { dropForeignExceptions } from "./utils/posthog/dropForeignExceptions";

const root = ReactDOM.createRoot(document.getElementById("root"));

const options = {
  api_host: process.env.REACT_APP_POSTHOG_HOST,
  defaults: '2025-05-24',
  autocapture: false,
  capture_pageview: false,
  capture_exceptions: true,
  disable_session_recording: true,
  capture_performance: { web_vitals: false },
  before_send: [dropForeignExceptions, maskQuickLinkToken],
  opt_out_capturing_by_default:
    process.env.NODE_ENV === "development" &&
    process.env.REACT_APP_POSTHOG_CAPTURE_IN_DEVELOPMENT !== "true",
}

root.render(
  <React.StrictMode>
    <PostHogProvider apiKey={process.env.REACT_APP_POSTHOG_KEY} options={options}>
      <PostHogErrorBoundary fallback={<AppCrashFallback />}>
        <App />
      </PostHogErrorBoundary>
    </PostHogProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/serviceWorker.js")
      .then((registration) => {
        console.log(
          "Service Worker registered with scope:",
          registration.scope
        );
      })
      .catch((error) => {
        console.error("Service Worker registration failed:", error);
      });
  });
}
